import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";

import HelpComponent from "../HelpComponent";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

const _FM_GroupAutodistributeFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [priceCategory, setpriceCategory] = useState(null);
  const [priceCategories, setPriceCategories] = useState([]);
  const [reservedFromDate, setReservedFromDate] = useState(null);
  const [reservedToDate, setReservedToDate] = useState(null);
  const [reservationStatus, setReservationStatus] = useState('confirmed');
  const [loading, setLoading] = useState(false);

  const reservationStatuses = [
    {label: t('pending'), value: 'pending'},
    {label: t('confirmed'), value: 'confirmed'},
  ];

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    apiCall('get', 'accommodation')
      .then(response => {
        localStorage.setItem('selectedAccommodation', response.data.data.items[0].id)
        apiCall('get', 'price-category?search[accommodation][operator]=%3D&search[accommodation][value]=' + (localStorage.getItem('selectedAccommodation') ?? response.data.data.items[0].id))
          .then(response => {
            setPriceCategories(response.data.data.items)
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, []);

  return (
    <>
      <Panel className={"p-mt-3"}>
        <h3 className={"p-mt-0"}>
          {t('group_distribute')}
        </h3>
        <HelpComponent type={"section"} tabNumber={2}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-4 p-xl-4"}>
            <div className="p-field p-fluid">
              <HelpComponent type={"field"} field={"price_category"}/>
              <label htmlFor="price_category">{t('pricecategory')}</label>
              <span className="p-d-block">
                    <Dropdown  options={priceCategories}
                              filter
                              optionLabel="name"
                              optionValue="id"
                              id={"price_category"}
                              emptyMessage={t('empty_message')}
                              onChange={(e) => {
                                setpriceCategory(e.value)
                              }}
                              value={priceCategory}
                    />
                  </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4 p-xl-4"}>
            <div className="p-field p-fluid">
              <HelpComponent type={"field"} field={"from"}/>
              <label htmlFor="reserved_period">{t('reserved_from')} - {t('reserved_to')}</label>
              <Calendar
                id={"reserved_period"}
                value={reservedFromDate ? [reservedFromDate, reservedToDate] : null}
                locale="default"
                dateFormat={t('YY-MM-DD')}
                selectionMode="range"
                showIcon
                onChange={(e) => {
                  setReservedFromDate(e.value?.[0] || null)
                  setReservedToDate(e.value?.[1] || null)
                }}
              />
            </div>
          </div>
          <div className={"p-col-12 p-lg-4 p-xl-4"}>
            <div className="p-field p-fluid">
              <HelpComponent type={"field"} field={"status"}/>
              <label htmlFor="reservation_status">{t('status')}</label>
              <span className="p-d-block">
                <Dropdown
                  options={reservationStatuses}
                  optionLabel="label"
                  optionValue="value"
                  id="reservation_status"
                  emptyMessage={t('empty_message')}
                  onChange={(e) => {
                    setReservationStatus(e.value)
                  }}
                  value={reservationStatus}
                />
              </span>
            </div>
          </div>
        </div>
        <div className={"p-grid"}>
          <div className={"p-col"}>
          </div>
          <div className={"p-col p-text-right p-col-align-center"}>
            <Button type="button" aria-label={t('save')} icon={"pi pi-save"}
                    label={t('distribute')}
                    loading={loading}
                    onClick={() => {
                      setLoading(true)
                      const payload = {
                        priceCategory: priceCategory,
                        status: reservationStatus
                      };

                      if (reservedFromDate && reservedToDate) {
                        payload.from = moment(`${moment(reservedFromDate).format('YYYY-MM-DD')}T15:00:00`).format('YYYY-MM-DDTHH:mm:ssZ');
                        payload.to = moment(`${moment(reservedToDate).format('YYYY-MM-DD')}T11:00:00`).format('YYYY-MM-DDTHH:mm:ssZ');
                      }

                      apiCall('post', 'group/' + props.groupId + '/auto-distribute', payload)
                        .then(response => {
                          window.App.toastShow('success', t('success'), response.data.message)
                          window.App.setState({
                            rerenderGroupList: Math.random()
                          })
                          navigate(-1)
                          setLoading(false)
                        })
                        .catch(error => {
                          setLoading(false)
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                    }}
                    className="p-button-success p-ml-2"/>
          </div>
        </div>
      </Panel>
    </>
  )
}
export default withTranslation('common')(_FM_GroupAutodistributeFormComponent);
